var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1493.463,
    height: 366.772,
    viewBox: "0 0 1493.463 366.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39315",
    "data-name": "Group 39315",
    transform: "translate(-296.826 -251.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Logo",
    transform: "translate(296.826 251.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M346.04,174.08a76.65,76.65,0,1,1,76.65-76.65,76.743,76.743,0,0,1-76.65,76.65m0-121.669A45.019,45.019,0,1,0,391.059,97.43,45.066,45.066,0,0,0,346.04,52.411",
    transform: "translate(715.88 50.868)",
    fill: "#4aba6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M434.583,188.324H267.49V68.42H434.583ZM299.121,156.693H402.952V100.051H299.121Z",
    transform: "translate(710.792 178.449)",
    fill: "#4aba6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M52.92,189.517V22.02H87.972V158.7h67.86V22.02h35.052v167.5Z",
    transform: "translate(136.167 54.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M177.447,23.15V53.678a49.635,49.635,0,0,0-12.027-1.287c-19.162,0-30.859,9.747-30.859,32.771V192.634H99.51V80.932c0-38.95,21.737-60.062,60.724-60.062a61.5,61.5,0,0,1,17.213,2.28",
    transform: "translate(260.937 51.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M211.826,198.489c-51.934,0-89.266-37.994-89.266-88.935,0-51.6,37.332-88.935,88.641-88.935,49.028,0,82.461,37.663,82.461,88.935a79.743,79.743,0,0,1-.956,12.652H159.267c4.561,27.585,24.348,44.8,52.927,44.8,20.781,0,35.714-7.466,47.7-22.73l20.45,21.112c-16.588,22.068-39.943,33.1-68.522,33.1M159.23,96.865H258.9c-2.612-26.629-21.443-45.46-48.366-45.46-27.622,0-46.748,17.875-51.309,45.46",
    transform: "translate(322.665 50.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M215.58,109.545c0-51.308,37.663-88.935,88.935-88.935,51.308,0,89.265,37.663,89.265,88.935,0,50.977-37.994,88.935-89.265,88.935-51.6.037-88.935-37.957-88.935-88.935m142.524-.331c0-33.764-22.068-57.782-53.552-57.782C273.4,51.432,251,75.449,251,109.214,251,142.647,273.4,167,304.551,167c31.484,0,53.552-24.348,53.552-57.782",
    transform: "translate(571.775 50.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M318.58,22.02h35.052V189.554H318.58Z",
    transform: "translate(847.612 54.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M457.462,52.548H372.757V158.7h85.037v30.822H338V22.02H457.462Z",
    transform: "translate(899.619 54.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M437.3,90.436l21.443,10.372c20.449,9.747,36.044,22.4,36.044,48.035,0,28.909-22.73,49.653-59.4,49.653-35.052,0-54.545-20.45-60.394-43.18l26.96-14.933c2.905,13.977,14.6,28.578,34.426,28.578,13.977,0,23.687-7.135,23.687-20.45,0-9.416-6.51-15.595-22.068-22.73L418.833,116.7c-20.45-9.416-36.376-21.112-36.376-48.7,0-25.967,23.061-47.41,54.214-47.41s49.359,16.882,58.113,37.663L469.773,72.524C464.256,59.54,453.222,49.462,437.3,49.462c-12.984,0-22.069,7.135-22.069,18.169,0,10.151,6.473,15.668,22.069,22.8",
    transform: "translate(998.679 50.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3171",
    "data-name": "Group 3171",
    transform: "translate(641.963 3.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M215.244,115.49,193.1,93.385,224,62.453,192.33,30.822,214.471,8.68l53.809,53.773Z",
    transform: "translate(-132.452 15.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M176.05,107.465v136.6h142.6V209.052H211.212V2.2H176.05V54.685",
    transform: "translate(-176.05 -2.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M171.4,79.863a68.855,68.855,0,0,0-6.547-29.5C153.412,20.757,124.687,1.3,88.2,1.3H1.51V245.484H37.04v-86.8H88.2c36.486,0,65.285-19.6,76.687-49.359A68.67,68.67,0,0,0,171.4,79.863Zm-79.74,50.683L38.989,77.877,90.923,25.943l20.229,20.229-31.7,31.7,32.477,32.477Z",
    transform: "translate(-1.51 -1.3)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.01e1a8abc1c227f09dda157d2164b187.svg";
export { ForwardRef as ReactComponent };